import React, { FC } from 'react';
import { VirtualizedMenuList } from 'components/atoms/select/custom-components';
import { MultiUserFieldFilter } from '../filters/multi-user';
import { EditorComponents, UserEditorComponents } from './editor-components';
import { MultiSelectBaseCriteria } from './multi-select-base';
import { useUserOptions } from './use-user-options';

interface Props {
  filter: MultiUserFieldFilter;
  onChange: (filter: MultiUserFieldFilter) => void;
  components?: EditorComponents;
}

export const MultiUserCriteria: FC<Props> = ({
  filter,
  onChange,
  components,
}) => {
  const options = useUserOptions(filter?.field?.metaData?.users);

  return (
    <MultiSelectBaseCriteria
      components={{
        ...UserEditorComponents,
        MenuList: VirtualizedMenuList,
        ...components,
      }}
      filter={filter}
      onChange={onChange as any}
      options={options}
      type="user"
    />
  );
};
